import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'
import router from '../Routes'
import swal from 'sweetalert2'
import store from '@/store/index'

Vue.use(Vuex)
const fb = require('../firebaseConfig.js')

// handle page reload

export default {
  // namespaced: true,

  state:     {
    redirectAfterLogin: null,

    currentUser:  {
      fullName: '',
    },
    error:        null,
    loading:      false,
    trips:        [],
    currentView:  null,
    selectedTrip: null,

    userProfile: [],
  },
  mutations: {

    setRedirectAfterLogin (state, val)
    {
      state.redirectAfterLogin = val
    },
    setCurrentUser (state, val)
    {
      state.currentUser = val
    },
    setUserProfile (state, val)
    {
      val.fullName       = val.fullName || 'CrazyTrip User'
      val.profilePicture = val.profilePicture || '/img/default-avatar.png'

      state.userProfile = val
    },
    setSelectedTrip (state, payload)
    {
      if(state.selectedTrip && payload && state.selectedTrip.id === payload.id)
      {
        return
      }

      console.log('set SelectedTrip ', payload)

      state.selectedTrip = payload
    },

    setError (state, payload)
    {
      state.error = payload
    },
    setLoading (state, payload)
    {
      state.loading = payload
    },
  }, // mutations

  actions: {
    redirectAfterLogin({commit}, payload)
    {
      commit('setRedirectAfterLogin', payload)

    },
    userSignUpWithEmail ({commit}, payload)
    {
      commit('setLoading', true)
      fb.auth.createUserWithEmailAndPassword(payload.email, payload.password)
        .then(firebaseUser => {

          firebaseUser.user.updateProfile({
            displayName: payload.fullName
          })

          fb.usersCollection.doc(firebaseUser.user.uid).set({
            uid:       firebaseUser.user.uid,
            createdOn: new Date(),
            updatedOn: new Date(),
            fullName:  payload.fullName,
          }).then(ref => {
            store.dispatch('fetchUserProfile')

          }).catch(err => {

            console.error(err)
          })

          commit('setCurrentUser', firebaseUser.user)
          commit('setLoading', false)
          commit('setError', null)
          router.push('/explore')
        })
        .catch(error => {
          commit('setError', error.message)
          commit('setLoading', false)
        })
    },
    userSignInWithEmail ({commit}, payload)
    {
      commit('setLoading', true)
      fb.auth.signInWithEmailAndPassword(payload.email, payload.password)
        .then(firebaseUser => {
          commit('setCurrentUser', firebaseUser.user)
          commit('setLoading', false)
          commit('setError', null)
          router.push('/explore')
        })
        .catch(error => {
          commit('setError', error.message)
          commit('setLoading', false)
        })
    },
    userSignInWithProvider ({commit}, provider)
    {
      commit('setLoading', true)

      firebase.auth().signInWithPopup(provider)
        .then(firebaseUser => {
          
          commit('setCurrentUser', firebaseUser.user)

          fb.usersCollection.doc(firebaseUser.user.uid).get().then(function (doc) {

            if (doc.exists)
            {
              store.dispatch('fetchUserProfile')
            }
            else
            {
              fb.usersCollection.doc(firebaseUser.user.uid).set({
                uid:       firebaseUser.user.uid,
                createdOn: new Date(),
                updatedOn: new Date(),
                fullName:  firebaseUser.user.displayName,
              }).then(ref => {
                store.dispatch('fetchUserProfile')
              }).catch(err => {

                console.error(err)
              })
            }
          })

          commit('setLoading', false)

          router.push('/explore')
        })
        .catch(error => {
          commit('setError', error.message)
          commit('setLoading', false)

          //"auth/account-exists-with-different-credential"
          var that = this
          swal({
            title:              'Error',
            text:               error.message,
            type:               'warning',
            confirmButtonClass: 'md-button md-success',
          }).then((result) => {

          })

        })
    },

    fetchUserProfile ({commit, state, dispatch})
    {
      dispatch('userProfiles/clearProfile', state.currentUser.uid );

      dispatch('userProfiles/retreiveProfile', state.currentUser.uid ).then(function (userProfile) {

        commit('setUserProfile', userProfile)

      }).catch(err => {
        console.log(err)
      })
    },
    autoSignIn ({commit}, payload)
    {
      //   fb.auth.refresh_token()
      commit('setCurrentUser', payload)
    },
    userSignOut ({commit})
    {
      firebase.auth().signOut()

      commit('setCurrentUser', null)

      router.push('/')
    },
  }, // actions

  getters: {
    redirectAfterLogin(state)
    {
      return state.redirectAfterLogin
    },
    selectedTrip (state)
    {
      return state.selectedTrip
    },

    isAuthenticated (state)
    {
      return state.currentUser !== null && state.currentUser !== undefined && state.currentUser.uid
    },
    currentUser (state)
    {
      return state.currentUser
    },
    currentUserProfile (state)
    {
      return state.userProfile
    },

  },
}